import { combineReducers } from 'redux';
import { handleActions } from 'redux-actions';
import merge from 'lodash/merge';
import { fetchPublisherPlanUsage } from '../routines';
import { INCREASE_PLAN_CURRENT_USAGE, DECREASE_PLAN_CURRENT_USAGE } from '../actions/types';

const current = handleActions(
  {
    [fetchPublisherPlanUsage.SUCCESS]: (state, { payload: { usage } }) => {
      const { current = {} } = usage || {};
      return merge({}, state, { ...current });
    },
    [INCREASE_PLAN_CURRENT_USAGE]: (state, { payload: { type } }) => {
      const oldValue = state[type];
      const nvalue = oldValue + 1;
      return merge({}, state, { [type]: nvalue });
    },
    [DECREASE_PLAN_CURRENT_USAGE]: (state, { payload: { type } }) => {
      const oldValue = state[type];
      const nvalue = oldValue > 0 ? oldValue - 1 : 0;
      return merge({}, state, { [type]: nvalue });
    },
  },
  {}
);

const limits = handleActions(
  {
    [fetchPublisherPlanUsage.SUCCESS]: (state, { payload: { usage } }) => {
      const { limits = {} } = usage || {};
      return merge({}, state, { ...limits });
    },
  },
  {}
);

const features = handleActions(
  {
    [fetchPublisherPlanUsage.SUCCESS]: (state, { payload: { usage } }) => {
      const { features = [] } = usage || {};
      return features;
    },
  },
  []
);

export default combineReducers({
  current,
  limits,
  features,
});
